import { useI18n } from '../i18n'

export default function LanguageToggle() {
  const { lang, setLang } = useI18n()
  return (
    <select className="input" value={lang} onChange={e => setLang(e.target.value as any)} title="Language">
      <option value="it">IT</option>
      <option value="en">EN</option>
    </select>
  )
}

